import {
    request
} from "./request";

export function getFilteredSpliceVariantByGenename(genename) {
    return request({
        url: '/ascancer/api/browse/knowledge',
        params: {
            genename,
        }
    })
}

export function getFilteredSpliceVariantByCancername(cancername) {
    return request({
        url: '/ascancer/api/browse/knowledge',
        params: {
            cancername,
        }
    })
}

export function getFilteredSpliceVariantByAstype(astype) {
    return request({
        url: '/ascancer/api/browse/knowledge',
        params: {
            astype,
        }
    })
}

export function getFilteredSpliceVariantByRegulation(regulation) {
    return request({
        url: '/ascancer/api/browse/knowledge',
        params: {
            regulation
        }
    })
}

export function getFilteredSpliceVariantByFunctional(functional) {
    return request({
        url: '/ascancer/api/browse/knowledge',
        params: {
            functional
        }
    })
}